import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Crashlytics from '@/services/Crashlytics'
import 'animate.css/animate.css'
import './style/main.scss'
import { bootApp } from '@/services/AppBoot.js'

const app = createApp(App)

bootApp({ app, router })
  .then(() => app.mount('#app'))
  .catch(e => Crashlytics.recordExceptionWithStacktrace('Vue initialization failed', e))
